import React from 'react';
import {createPortal} from 'react-dom';
import {accessLock} from '../assets/images/images';
import PrimaryButton from './PrimaryButton';
import SecondaryButton from './SecondaryButton';
import {seeHowItWorksLinks} from '../helpers/constants';

export function RequestAccessModal({isOpen, onClose, resourceName = ''}) {
  const handleBackdropClick = e => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  const handleSeeHowItWorks = () => {
    if (resourceName?.length > 0) {
      window.open(seeHowItWorksLinks[resourceName], '_blank').focus();
    }
  };

  return createPortal(
    <div
      className="fixed inset-0 bg-black bg-opacity-70 backdrop-blur-[16px] flex justify-center items-center z-[9999]"
      onClick={handleBackdropClick}
    >
      <div className="bg-white rounded-2xl p-12 max-w-lg w-full">
        <div className="flex flex-col items-center text-center space-y-6">
          <img src={accessLock} alt="access lock" />
          <div>
            <h2 className="text-base font-medium mb-4">
              You do not have access to this feature
            </h2>

            <p className="text-sm text-body">
              Detect duplicate user registrations and blacklist suspicious
              accounts using Custom List, keeping your platform secure and free
              from unauthorized access.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-6 w-full justify-center px-5">
            <PrimaryButton
              buttonText="Request Access"
              className="lg:min-w-[183px]"
            />
            <SecondaryButton
              buttonText=" See how it works"
              className="lg:min-w-[164px] border !border-[#dfe4eb] !outline-none"
              onClick={handleSeeHowItWorks}
              disabled={resourceName?.length === 0}
            />
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
}
